import { applySnapshot, flow, types } from "mobx-state-tree";
import { ErrorModel } from "../../components/common/error";
import { IInput } from "../../utils/common-interface";
import customtypes from "../../utils/mobx-types-helper";
import roleAPI from "./RoleService";

export const RoleModel = types
  .model("RoleModel", {
    isSelected: types.maybeNull(types.boolean),
    roleId: customtypes.optional(types.string, ""),
    roleName: customtypes.optional(types.string, ""),
  })
  .views((self: any) => ({}))
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
    setAllField: (data: any) => {
      Object.keys(data).forEach((key) => {
        try {
          self[key] = data[key];
        } catch (e) {
          console.log("exception on mapping key:", key);
        }
      });
    },
  }));

export const RoleListModel = types
  .model("RoleListModel", {
    list: customtypes.optional(types.array(RoleModel), []),
    error: types.optional(ErrorModel, {}),
  })
  .views((self: any) => ({}))
  .actions((self: any) => ({
    getRole: flow(function*() {
      try {
        const result = yield roleAPI.getRole();
        self.list = result.data;
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        //
      }
    }),
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
    setAllField: (data: any) => {
      Object.keys(data).forEach((key) => {
        try {
          self[key] = data[key];
        } catch (e) {
          console.log("exception on mapping key:", key);
        }
      });
    },
  }));

export type IRoleModel = typeof RoleModel.Type;
export type IRoleListModel = typeof RoleListModel.Type;
